import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../register/actions';
import * as RegisterSelectors from 'shared_redux/selectors/view/register';
import View from './view';

const mapStateToProps = (state, props) => {
    document.title = "RepOne - Athlete Signup";
    
    // Get query parameters
    const query = new URLSearchParams(props.location?.search || '');
    const email = query.get('email') || '';
    const athleteInvite = query.get('athlete_invite') || '';
    
    const registered = RegisterSelectors.getIsRegistered(state);

    return {
        registering: RegisterSelectors.getIsRegistering(state),
        registered,
        beta: false,
        email: email || RegisterSelectors.getEmail(state),
        password: RegisterSelectors.getPassword(state),
        firstName: RegisterSelectors.getFirstName(state) || '',
        middleName: RegisterSelectors.getMiddleName(state) || '',
        lastName: RegisterSelectors.getLastName(state) || '',
        athleteInvite: athleteInvite || RegisterSelectors.getInviteCode(state) || '',
        account_id: RegisterSelectors.getAccountId(state),
        is_active: RegisterSelectors.getIsActive(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateEmail: Actions.updateEmail,
        updatePassword: Actions.updatePassword,
        updateFirstName: Actions.updateFirstName,
        updateMiddleName: Actions.updateMiddleName,
        updateLastName: Actions.updateLastName,
        updateInviteCode: Actions.updateInviteCode,
        register: Actions.register,
    }, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(View)); 